// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__3V2BQ","content":"styles_content__aqDuA","selectAll":"styles_selectAll__mpFMd"};